import { HTMLAttributes, MouseEventHandler, PropsWithChildren } from 'react';
import { IconProps } from '@/components/icon/types';

export type ChipsProps = PropsWithChildren<{
  label: string;
  variant?: 'default' | 'outlined' | 'filled' | 'selected' | 'appointment';
  size?: 'small' | 'medium' | 'large';
  icon?: IconProps;
  onClick?: MouseEventHandler;
  selected?: boolean;
  disabled?: boolean;
  selectionMode: 'single' | 'multiple';
  border?: boolean;
  classNameLabel?: string;
  className?: string;
}> &
  HTMLAttributes<HTMLDivElement>;

export const sizeClass = {
  small: 'px-2 py-1 rounded-[99px] text-[12px]',
  medium: ' px-4 py-2 rounded-[99px] text-[16px]',
  large: 'px-4 py-3 rounded-[99px] text-[21px]',
};
export const variantClass = {
  default: 'text-neutral-500',
  outlined: 'outline outline-2 outline-offset-2 outline-sky-950',
  filled: 'bg-sky-950 text-white',
  selected: 'bg-sky-950 text-white',
  // Appointment-slot pill: bordered, white when idle; brand-tinted when chosen.
  appointment:
    'border border-solid border-neutral-200 bg-white text-slate-700 hover:border-brand-300',
  appointmentSelected:
    'border border-solid border-brand-700 bg-brand-700/10 text-brand-700',
};

export type ChipsWrapperProps = {
  options: string[];
  selectedOptions: string[];
  onSelectionChange: (selected: string[]) => void;
  variant?: 'inline-wrap';
  selectionMode: 'single' | 'multiple';
  resetPosition?: boolean;
};
